import { render, staticRenderFns } from "./AddInstrumentationsModal.vue?vue&type=template&id=285549d0&scoped=true"
import script from "./AddInstrumentationsModal.vue?vue&type=script&lang=js"
export * from "./AddInstrumentationsModal.vue?vue&type=script&lang=js"
import style0 from "./AddInstrumentationsModal.vue?vue&type=style&index=0&id=285549d0&prod&scoped=true&scss=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285549d0",
  null
  
)

export default component.exports